// src/store/modules/offersIbp.js
import axios from 'axios';

const API_BASE = 'https://apidash.smartpress.kz/api';

// !!! если на бэке другой путь (например /offers-ibp-kanban),
// просто поправьте ниже ENDPOINT-ы под ваш реальный API.

const state = {
  offers: [],
  isLoading: false,
  addKpModal: false,
  addInvoiceModal: false,
  invoiceData: null,
  offerDetails: null,
  currentOffer: null,
  totalOffers: 0,
  selectedOffer: null,
  showPaymentModal: false,
  selectedOfferId: null,
  isOfferDeliveryModalOpen: false,
  currentBooks: [],
  currentOfferId: null, 
  booksModal: false,
};

const getters = {
  offers: (state) => state.offers,
  isLoading: (state) => state.isLoading,
  addKpModal: (state) => state.addKpModal,
  addInvoiceModal: (state) => state.addInvoiceModal,
  invoiceData: (state) => state.invoiceData,
  offerDetails: (state) => state.offerDetails || {},
  currentOffer: (state) => state.currentOffer,
  selectedOffer: (state) => state.selectedOffer,
  showPaymentModal: (state) => state.showPaymentModal,
  selectedOfferId: (state) => state.selectedOfferId,
  allOffers: (state) => state.offers,
  currentBooks: (state) => state.currentBooks || [],
  isBooksModalOpen: (state) => state.booksModal === true,
  currentOfferId: (state) => state.currentOfferId,
};

const mutations = {
  SET_FLAG(state, { id, key, value }) {
    const list = state.offers || state.items || [];
    const idx = list.findIndex(o => o.id === id);
    if (idx !== -1) {
      list[idx][key] = value;
    }
  },
  removeOffer(state, offerId) {
    state.offers = state.offers.filter(offer => offer.id !== offerId);
  },
  setCurrentBooks(state, items) {
    state.currentBooks = items;
  },
  setBooksModal(state, status) {
    state.booksModal = status;
  },
  setCurrentOfferId(state, id) {
    state.currentOfferId = id;
  },
  openOfferDeliveryModal(state, offer) {
    state.selectedOffer = offer;
    state.selectedOfferId = offer.id;
    state.isOfferDeliveryModalOpen = true;
  },
  closeOfferDeliveryModal(state) {
    state.selectedOffer = null;
    state.selectedOfferId = null;
    state.isOfferDeliveryModalOpen = false;
  },
  SET_OFFERS(state, offers) {
    state.offers = offers;
  },
  SET_TOTAL_OFFERS(state, total) {
    state.totalOffers = total;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ADD_KP_MODAL(state, status) {
    state.addKpModal = status;
  },
  SET_ADD_INVOICE_MODAL(state, status) {
    state.addInvoiceModal = status;
  },
  SET_INVOICE_DATA(state, data) {
    state.invoiceData = data;
  },
  CLOSE_ADD_KP_MODAL(state) {
    state.addKpModal = false;
    state.invoiceData = null;
  },
  CLOSE_ADD_INVOICE_MODAL(state) {
    state.addInvoiceModal = false;
    state.invoiceData = null;
  },
  SET_OFFER_DETAILS(state, offer) {
    state.offerDetails = offer;
  },
  SET_CURRENT_OFFER(state, offer) {
    state.currentOffer = offer;
  },
  SET_SELECTED_OFFER(state, offer) {
    state.selectedOffer = offer;
  },
  SET_SHOW_PAYMENT_MODAL(state, status) {
    state.showPaymentModal = status;
  },
};

// --- helpers for status search mapping ---
const RAW_STATUSES = [
  'in process',
  'accept',
  'rejected',
  'Request for invoice',
  'Invoice and contract sent',
  'typo_finish',
  'stock',
  'wap',
  'done',
  'archieve',
];

const normalize = (s) => (s ?? '').toString().toLowerCase().trim();

const STATUS_ALIASES = {
  'в работе': 'in process',
  'работа': 'in process',
  'принят': 'accept',
  'отклонен': 'rejected',
  'запрос счета': 'Request for invoice',
  'счет и договор отправлены': 'Invoice and contract sent',
  'типография завершена': 'typo_finish',
  'склад': 'stock',
  'ожидание оплаты': 'wap',
  'сдан': 'done',
  'архив': 'archieve',
  'archive': 'archieve',
};

function toRawStatusIfAny(input) {
  const q = normalize(input);
  if (!q) return null;

  const exactRaw = RAW_STATUSES.find((k) => normalize(k) === q);
  if (exactRaw) return exactRaw;

  for (const [alias, raw] of Object.entries(STATUS_ALIASES)) {
    if (normalize(alias) === q) return raw;
  }

  for (const raw of RAW_STATUSES) {
    if (normalize(raw).includes(q)) return raw;
  }
  for (const [alias, raw] of Object.entries(STATUS_ALIASES)) {
    if (normalize(alias).includes(q) || q.includes(normalize(alias))) return raw;
  }

  return null;
}

function buildOfferParams(base = {}) {
  const params = { per_page: 50, sort_by: 'created_at', sort_dir: 'desc', ...base };
  if (params.search && params.search.toString().trim()) {
    const raw = toRawStatusIfAny(params.search);
    if (raw) params.search = raw;
  }
  return params;
}

const actions = {
  async fetchOffersPaginated(
    { commit },
    { page = 1, per_page = 50, search = '', sort_by = 'created_at', sort_dir = 'desc' }
  ) {
    commit('SET_LOADING', true);
    try {
      const token = localStorage.getItem('token');
      const params = buildOfferParams({ page, per_page, search, sort_by, sort_dir });

      const response = await axios.get(`${API_BASE}/offers-ibp`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });

      commit('SET_OFFERS', response.data.data);
      commit('SET_TOTAL_OFFERS', response.data.total);
    } catch (error) {
      console.error('Error fetching IBP offers:', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchOffers({ commit }) {
    commit('SET_LOADING', true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE}/offers-ibp-kanban`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      commit('SET_OFFERS', response.data.offers);
      commit('SET_TOTAL_OFFERS', response.data.offers.length);
    } catch (error) {
      console.error('Error fetching IBP offers (kanban):', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async toggleFlag({ commit }, { id, key, value }) {
    const token = localStorage.getItem('token');
    const keyMap = {
      isbn: 'has_isbn',
      contract_file: 'has_contract',
      invoice_file: 'has_invoice',
      act_file: 'has_act',
      esf_file: 'has_esf',
      author_contract_file: 'has_author_contract',
      sales_contract_file: 'has_sales_contract',
      in_price: 'in_price',
      in_store: 'in_store',
    };
    const dbKey = keyMap[key] || key;

    commit('SET_FLAG', { id, key: dbKey, value });

    try {
      await axios.patch(
        `${API_BASE}/offers-ibp/${id}/toggle-flag`,
        { key: dbKey, value },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (e) {
      commit('SET_FLAG', { id, key: dbKey, value: !value });
      throw e;
    }
  },

  async openOfferDeliveryModal({ commit }, offerId) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE}/offers-ibp/${offerId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      commit('openOfferDeliveryModal', response.data);
    } catch (error) {
      console.error('Failed to fetch IBP offer for delivery modal:', error);
    }
  },

  openPaymentModal({ commit }, offer) {
    if (offer && offer.id) {
      commit('SET_SELECTED_OFFER', offer);
      commit('SET_SHOW_PAYMENT_MODAL', true);
    } else {
      console.error('Offer is undefined or missing ID:', offer);
    }
  },

  closePaymentModal({ commit }) {
    commit('SET_SHOW_PAYMENT_MODAL', false);
    commit('SET_SELECTED_OFFER', null);
  },

  openKPModal({ commit }, offerData) {
    commit('SET_CURRENT_OFFER', offerData);
    commit('SET_ADD_KP_MODAL', true);
  },

  openInvoiceModal({ commit }, offerData) {
    commit('SET_CURRENT_OFFER', offerData);
    commit('SET_ADD_INVOICE_MODAL', true);
  },

  closeKpModal({ commit }) {
    commit('CLOSE_ADD_KP_MODAL');
  },

  closeInvoiceModal({ commit }) {
    commit('CLOSE_ADD_INVOICE_MODAL');
  },

  async createOffer({ }, invoiceData) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_BASE}/offers-ibp`,
        invoiceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('IBP Offer created:', response.data);
    } catch (error) {
      console.error('Error creating IBP offer:', error);
      throw error;
    }
  },

  async fetchOfferDetails({ commit }, offerId) {
    commit('SET_LOADING', true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE}/offers-ibp/${offerId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      commit('SET_OFFER_DETAILS', response.data);
      commit('SET_CURRENT_OFFER', response.data);
    } catch (error) {
      console.error('Error fetching IBP offer details:', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateOffer({ dispatch }, offerData) {
    try {
      const token = localStorage.getItem('token');
      const offerId = offerData.get('offer_id');

      const response = await axios.post(
        `${API_BASE}/offers-ibp/${offerId}`,
        offerData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log('IBP Offer updated:', response.data);

      await dispatch('fetchOffersPaginated', {
        page: 1,
        per_page: 50,
        search: '',
        sort_by: 'created_at',
        sort_dir: 'desc',
      });
    } catch (error) {
      console.error('Error updating IBP offer:', error);
      throw error;
    }
  },

  async updateInvoice({ dispatch }, offerData) {
    try {
      const token = localStorage.getItem('token');
      const offerId = offerData.get('offer_id');

      const response = await axios.post(
        `${API_BASE}/offers-ibp/${offerId}/invoice`,
        offerData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log('IBP Offer invoice updated:', response.data);

      await dispatch('fetchOffersPaginated', {
        page: 1,
        per_page: 50,
        search: '',
        sort_by: 'created_at',
        sort_dir: 'desc',
      });
    } catch (error) {
      console.error('Error updating IBP offer invoice:', error);
      throw error;
    }
  },

  async deleteOffer({ commit }, offerId) {
    const token = localStorage.getItem('token');
    await axios.delete(`${API_BASE}/offers-ibp/${offerId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    commit('removeOffer', offerId);
  },

  async copyOffer({ dispatch }, offerId) {
    const token = localStorage.getItem('token');
    await axios.post(
      `${API_BASE}/offers-ibp/${offerId}/copy`,
      null,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    await dispatch('fetchOffers');
  },

  async updateOfferInvoice({ dispatch }, invoiceData) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token is missing. Please login again.');

      const response = await axios.post(
        `${API_BASE}/offers-ibp/${invoiceData.offerId}/update-invoice`,
        invoiceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      console.log('IBP Invoice updated:', response.data);
      await dispatch('fetchOffers');
    } catch (error) {
      console.error('Error updating IBP invoice:', error);
      throw error;
    }
  },

  async saveInvoice({ commit, state }, { offer_id, progress }) {
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `${API_BASE}/invoices-ibp/${offer_id}/update-progress`,
        { progress },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const updatedOffers = state.offers.map((offer) =>
        offer.id === offer_id ? { ...offer, progress } : offer
      );
      commit('SET_OFFERS', updatedOffers);
    } catch (error) {
      console.error('Error updating IBP invoice progress:', error);
    }
  },

  openBooksModal({ commit }, offer) {
    if (!offer || !offer.id) return;
    commit('setCurrentOfferId', offer.id);
    const items = JSON.parse(JSON.stringify(offer.ibp_items || []));
    commit('setCurrentBooks', items);
    commit('setBooksModal', true);
  },

  async updateOfferItems({ dispatch }, { offerId, items }) {
    if (!offerId) throw new Error('offerId is required');
    const token = localStorage.getItem('token');
    await axios.patch(
      `${API_BASE}/offers-ibp/${offerId}/items`,
      { items },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    await dispatch('fetchOffers');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
